module.exports = __webpack_public_path__ + "assets/img/img265.492defeb.png";